import { render, staticRenderFns } from "./FaqBanner.vue?vue&type=template&id=ab854fb4&"
import script from "./FaqBanner.vue?vue&type=script&lang=js&"
export * from "./FaqBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports